/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "Reactodia",
  "tagline": "Visual interaction with graph data in a form of a diagram.",
  "favicon": "img/favicon.ico",
  "url": "https://reactodia.github.io",
  "baseUrl": "/",
  "organizationName": "reactodia",
  "projectName": "reactodia.github.io",
  "onBrokenLinks": "throw",
  "onBrokenMarkdownLinks": "warn",
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en"
    ],
    "path": "i18n",
    "localeConfigs": {}
  },
  "presets": [
    [
      "classic",
      {
        "docs": {
          "sidebarPath": "./sidebars.ts",
          "editUrl": "https://github.com/reactodia/reactodia.github.io/tree/main/"
        },
        "blog": false,
        "theme": {
          "customCss": "./src/css/custom.css"
        }
      }
    ]
  ],
  "plugins": [
    "./src/plugins/import-raw-source",
    "./src/plugins/configure-webpack",
    [
      "docusaurus-plugin-typedoc",
      {
        "entryPoints": [
          "./reactodia-workspace/src/workspace.ts",
          "./reactodia-workspace/src/forms/index.ts",
          "./reactodia-workspace/src/layout-sync.ts",
          "./reactodia-workspace/src/layout.worker.ts",
          "./reactodia-workspace/src/legacy-styles.tsx"
        ],
        "tsconfig": "./reactodia-workspace/tsconfig.typings.json",
        "readme": "none",
        "hideGroupHeadings": true,
        "excludePrivate": true,
        "excludeProtected": true,
        "excludeInternal": true,
        "excludeExternals": true,
        "enumMembersFormat": "htmlTable",
        "parametersFormat": "htmlTable",
        "propertiesFormat": "htmlTable",
        "tableColumnSettings": {
          "hideSources": true
        }
      }
    ]
  ],
  "themes": [
    "@docusaurus/theme-live-codeblock",
    [
      "/home/runner/work/reactodia.github.io/reactodia.github.io/node_modules/@easyops-cn/docusaurus-search-local/dist/server/server/index.js",
      {
        "hashed": true
      }
    ]
  ],
  "themeConfig": {
    "image": "img/reactodia-social-card.jpg",
    "navbar": {
      "title": "Reactodia",
      "logo": {
        "alt": "Reactodia Logo",
        "src": "img/reactodia-logo.svg"
      },
      "items": [
        {
          "type": "docSidebar",
          "sidebarId": "docs",
          "position": "left",
          "label": "Docs"
        },
        {
          "type": "docSidebar",
          "sidebarId": "api",
          "position": "left",
          "label": "API"
        },
        {
          "label": "Playground",
          "position": "left",
          "items": [
            {
              "to": "/playground/basic",
              "label": "Basic Workspace"
            },
            {
              "to": "/playground/rdf-explorer",
              "label": "RDF Explorer"
            },
            {
              "to": "/playground/style-customization",
              "label": "Style Customization"
            },
            {
              "to": "/playground/graph-authoring",
              "label": "Graph Authoring"
            },
            {
              "to": "/playground/sparql",
              "label": "SPARQL Navigator"
            },
            {
              "to": "/playground/stress-test",
              "label": "Stress Test"
            },
            {
              "to": "/playground/wikidata",
              "label": "Wikidata Explorer"
            },
            {
              "to": "/playground/classic-workspace",
              "label": "Classic Workspace"
            }
          ]
        },
        {
          "label": "Tools",
          "position": "left",
          "items": [
            {
              "to": "/tools/genealogical-tree-editor",
              "label": "Genealogical Tree Editor (α ver.)"
            }
          ]
        },
        {
          "href": "https://github.com/reactodia/reactodia-workspace",
          "label": "GitHub",
          "position": "right"
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Docs",
          "items": [
            {
              "label": "Intro",
              "to": "/docs"
            },
            {
              "label": "Concepts",
              "to": "/docs/category/concepts"
            },
            {
              "label": "Components",
              "to": "/docs/category/components"
            },
            {
              "label": "Examples",
              "to": "/docs/category/examples"
            }
          ]
        },
        {
          "title": "More",
          "items": [
            {
              "label": "Changelog",
              "href": "https://github.com/reactodia/reactodia-workspace/blob/master/CHANGELOG.md"
            },
            {
              "label": "GitHub",
              "href": "https://github.com/reactodia/reactodia-workspace"
            }
          ]
        }
      ],
      "copyright": "Copyright © 2026 AlexeyMz. Built with Docusaurus."
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [
        "json"
      ],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "liveCodeBlock": {
      "playgroundPosition": "top"
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": false
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": false,
      "useCssCascadeLayers": false
    },
    "experimental_faster": {
      "swcJsLoader": false,
      "swcJsMinimizer": false,
      "swcHtmlMinimizer": false,
      "lightningCssMinimizer": false,
      "mdxCrossCompilerCache": false,
      "rspackBundler": false,
      "rspackPersistentCache": false,
      "ssgWorkerThreads": false
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  }
};
